import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import InteractionPlugin from '@fullcalendar/interaction';
import Select from 'react-select';
import axios from 'axios';
import 'bootstrap';

export default function Byfarm(props) {
  const [events, setEvents] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const [items, setItems] = useState({ UnitId: "" });

  useEffect(() => {
    fetchUnitData();
    fetchEventData();
  }, []); // No need to add props as dependencies unless companyid changes

  // Fetch Unit Data
  async function fetchUnitData() {
    try {
      const UnitUrl = `${process.env.REACT_APP_APIURL}FramUnit/GetFramUnits?companyid=${props.companyid}`;
      const response = await axios.get(UnitUrl);
      const unitOptions = response.data.map((unit) => ({
        value: unit.unitId,
        label: unit.unitName,
      }));
      setUnits(unitOptions);
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  }

  // Fetch All Event Data
  async function fetchEventData() {
    setLoading(true); // Set loading to true
    try {
      const eventUrl = `${process.env.REACT_APP_APIURL}booking/GetEventList?companyid=${props.companyid}`;
      const response = await axios.get(eventUrl);
      const modifiedEvents = response.data.map((e) => ({
        ...e,
        title: e.title.replace(/  -  /g, `\n\r`).replace(/ - /g, `\n\r`).trim(),
      }));
      setEvents(modifiedEvents);
    } catch (error) {
      console.error("Error fetching event data:", error);
    } finally {
      setLoading(false); // Set loading to false
    }
  }

  // Fetch Event Data by Selected Unit
  async function fetchEventDataByUnit(companyId, unitId) {
    setLoading(true); // Set loading to true
    try {
      const eventUrl = `${process.env.REACT_APP_APIURL}booking/GetEventListbyunit?companyid=${companyId}&unitid=${unitId}`;
      const response = await axios.get(eventUrl);
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching events by unit:", error);
    } finally {
      setLoading(false); // Set loading to false
    }
  }

  // Handle Unit Selection Change
  const handleUnitChange = (selected) => {
    setSelectedUnit(selected);
    setItems({ ...items, UnitId: selected.value });
    fetchEventDataByUnit(props.companyid, selected.value);
  };

  // Refresh Function to Reset Unit Selection
  const refresh = () => {
    setItems({ UnitId: "" });
    setSelectedUnit(null);
    fetchEventData(); // Fetch all events again
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">By Farm</h4>
              <div className="shift-colors by-form-shift">
                <ul>
                  <li><span className="m_booking"></span>Morning</li>
                  <li><span className="e_booking"></span>Evening</li>
                  <li><span className="f_booking"></span>Full Day</li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              {/* Unit Selection */}
              <div className="mb-3 col-sm-3 mx-auto">
                <label className="form-label">Select Farm</label>
                <Select
                  name="unit"
                  value={selectedUnit}
                  options={units}
                  onChange={handleUnitChange}
                  isClearable
                  required
                />
              </div>

              {/* Calendar Section */}
              <div className="col-12 farm-one deal" data-amount="1">
                <div className="calender-render">
                  {loading ? (
                    <section className='loader_main'>
                    <span className="loader-5"></span>
                    </section>
                  ) : (
                    <FullCalendar
                      plugins={[dayGridPlugin, InteractionPlugin]}
                      initialView="dayGridMonth"
                      headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'timeGridWeek,timeGridDay',
                      }}
                      dayMaxEventRows={3}
                      events={events} // Events dynamically updated
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
